import { toPixel } from "../../helpers/strings";
import { getOffset } from "../../helpers/document";
import { deleteSegment, retrieveSegments } from "./ajax";
import { mapResponseSegmentToSegment } from "./helpers";
var SegmentContainer = /** @class */ (function () {
    function SegmentContainer(el, isAdmin) {
        this.el = el;
        this.current = null;
        this.isAdmin = isAdmin;
        this.addNewButton = el.querySelector('.ac-segments__create button');
        this.init();
        this.refreshSegments(this.el.dataset.initial);
    }
    SegmentContainer.prototype.init = function () {
        this.addNewButton.addEventListener('click', function () {
            AdminColumns.Modals.get('create_segment').open();
        });
    };
    SegmentContainer.prototype.checkPublicSectionState = function () {
        var publicSection = this.el.querySelector('.ac-segments__list.-global');
        if (!publicSection) {
            return;
        }
        if (this.el.querySelectorAll('.ac-segments__list.-global .ac-segments__list__items > *').length > 0) {
            publicSection.classList.add('-visible');
        }
        else {
            publicSection.classList.remove('-visible');
        }
    };
    SegmentContainer.prototype.show = function () {
        this.el.classList.add('-active');
    };
    SegmentContainer.prototype.hide = function () {
        this.el.classList.remove('-active');
    };
    SegmentContainer.prototype.moveToElement = function (el) {
        var offset = getOffset(el);
        this.el.style.left = toPixel(offset.left + Math.round(el.offsetWidth / 2));
        this.el.style.top = toPixel(offset.top);
    };
    SegmentContainer.prototype.removeSegment = function (id) {
        var row = this.el.querySelector(".ac-segments__list [data-id=\"" + id + "\"]");
        if (row) {
            row.remove();
            this.checkPublicSectionState();
        }
    };
    SegmentContainer.prototype.clearSegments = function () {
        this.el.querySelectorAll(".ac-segments__list__items").forEach(function (el) { return el.innerHTML = ''; });
    };
    SegmentContainer.prototype.addSegment = function (segment, isAdmin) {
        if (isAdmin === void 0) { isAdmin = false; }
        var element = document.createElement("div");
        var selector = segment.isGlobal() ? '.ac-segments__list.-global' : '.ac-segments__list.-personal';
        element.classList.add('ac-segment');
        element.dataset.id = segment.getId().toString();
        element.dataset.name = segment.getName();
        element.innerHTML = "<a class=\"ac-segment__label\" href=\"" + segment.getUrl() + "\">" + segment.getName() + "</a>";
        if (!segment.isGlobal() || isAdmin) {
            element.innerHTML += "<button class=\"ac-segment__action -delete\" data-action=\"delete\"><span class=\"dashicons dashicons-no-alt\"></span></button>";
        }
        this.el.querySelector(selector).querySelector('.ac-segments__list__items').insertAdjacentElement('beforeend', element);
        this.initSegmentEvents(element);
        this.checkPublicSectionState();
        return element;
    };
    SegmentContainer.prototype.setCurrent = function (id) {
        this.current = id;
        var segments = document.querySelectorAll('.ac-segments__list .ac-segment');
        for (var i = 0; i < segments.length; i++) {
            var segment_element = segments[i];
            segment_element.classList.remove('-current');
            if (segment_element.dataset.id === this.current) {
                segment_element.classList.add('-current');
            }
        }
    };
    SegmentContainer.prototype.initSegmentEvents = function (segment) {
        var _this = this;
        var id = segment.dataset.id;
        if (!segment) {
            return;
        }
        segment.querySelectorAll('[data-action=delete]').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                deleteSegment(id).then(function (r) {
                    if (r.data.success) {
                        _this.removeSegment(id);
                    }
                });
            });
        });
    };
    SegmentContainer.prototype.refreshSegments = function (current) {
        var _this = this;
        if (current === void 0) { current = null; }
        retrieveSegments().then(function (response) {
            _this.clearSegments();
            response.data.data.forEach(function (s) {
                var segment = mapResponseSegmentToSegment(s);
                if (segment) {
                    _this.addSegment(segment, _this.isAdmin);
                }
            });
            if (AdminColumns.hasOwnProperty('Tooltips')) {
                AdminColumns.Tooltips.init();
            }
            if (current) {
                _this.setCurrent(current);
            }
        });
        this.checkPublicSectionState();
    };
    return SegmentContainer;
}());
export default SegmentContainer;
